import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { isAxiosError } from 'shared/api/isAxiosError'
import { getErrorMessage } from '../../../errors/ApiError'
import { getApiErrorMessage } from '../../api/errors'

function useToastError() {
  const { t } = useTranslation()

  const notifyUnexpectedError = (error: unknown, opts?: { fallback?: string }) => {
    if (isAxiosError(error)) {
      // should be already handled by useQuery handlers
      return
    }

    let errorMessage = getErrorMessage(error)
    if (opts?.fallback) {
      errorMessage = opts?.fallback
    }

    toast.error(errorMessage, {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    })
  }

  const notifyApiError = (error: unknown) => {
    const { id, messages } = getApiErrorMessage(error)
    messages.forEach((message) => toast.error(
      id ? t('errors.messageWithTraceId', { message, traceId: id }) : message,
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      },
    ))
  }

  return {
    notifyUnexpectedError,
    notifyApiError,
  }
}

export default useToastError
